<div
  class="h-[400px] w-[400px] shadow-lg shadow-box shadow-gray-300 rounded-2xl flex items-center py-32 px-6 text-gray-500"
>
  <div class="flex flex-col gap-7 w-full">
    <div class="flex w-full">
      <img class="h-16" [src]="image" alt="" />
    </div>
    <div class="flex flex-col gap-5 text-sm">
      <p class="font-bold text-gray-600">{{ platform }}</p>
      <p>{{ text }}</p>
    </div>
    <div class="h-14 shadow-bttn flex items-center rounded-xl gap-3 font-semibold duration-100 hover:bg-gray-100">
      <button class="flex items-center gap-3 h-full w-full px-4 py-3" (click)="emit()">
        <ng-content select="[btnContent]"></ng-content>
      </button>
    </div>
  </div>
</div>
